
<template>
  <v-tooltip
    top
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        v-bind="attrs"
        v-on="on"
      >
        {{ title }}
      </v-btn>
    </template>
    <div>
      <p style="margin-bottom: 0px;">
        历史合同
      </p>
      <p
        v-for="item in contracts"
        :key="item.id"
        style="margin-bottom: 0px;"
      >
        {{ item.uid }}
      </p>
    </div>
  </v-tooltip>
</template>
<script>
  export default {
    props: {
      title: {
        type: String
      },
      contracts: {
        type: Array,
        default: () => []
      }
    }
  }
</script>